import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import KeywordDefinitionCommand from './keyworddefinitioncommand';
import { CkeditorConstants } from '../../src/utils';

const {
  command: { KEYWORD_DEFINITION },
} = CkeditorConstants;

export default class KeywordDefinitionUI extends Plugin {
  init() {
    this.editor.commands.add(KEYWORD_DEFINITION, new KeywordDefinitionCommand(this.editor));
  }
}